import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { SrcNotificationSettingsActions } from './src-notification-settings.actions';
import { SrcNotificationSettingsState } from './src-notification-settings.state';

export const initSrcNotificationSettingsState: SrcNotificationSettingsState = {
  data: null,
  loading: false,
  loaded: false,
  error: null,
};

export const srcNotificationSettingsReducer: ActionReducer<
  SrcNotificationSettingsState,
  Action
> = createReducer(
  initSrcNotificationSettingsState,

  on(
    SrcNotificationSettingsActions.getNotificationSettings.attempt,
    (state): SrcNotificationSettingsState => ({
      ...state,
      loading: true,
      loaded: false,
      error: null,
    })
  ),

  on(
    SrcNotificationSettingsActions.getNotificationSettings.success,
    (state, { data }): SrcNotificationSettingsState => ({
      ...state,
      data,
      loading: false,
      loaded: true,
    })
  ),

  on(
    SrcNotificationSettingsActions.getNotificationSettings.error,
    (state, { error }): SrcNotificationSettingsState => ({
      ...state,
      loading: false,
      loaded: false,
      error,
    })
  ),

  on(
    SrcNotificationSettingsActions.setNotificationSettings.attempt,
    (state): SrcNotificationSettingsState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    SrcNotificationSettingsActions.setNotificationSettings.success,
    (state, { data }): SrcNotificationSettingsState => ({
      ...state,
      data,
      loading: false,
    })
  ),

  on(
    SrcNotificationSettingsActions.setNotificationSettings.error,
    (state, { error }): SrcNotificationSettingsState => ({
      ...state,
      loading: false,
      error,
    })
  )
);
